/**
 * @generated SignedSource<<ede81bc067fa2b8c84ed51e90fb10825>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditQuestionCard_formQuestion$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"QuestionControls_question" | "QuestionInputs_question" | "QuestionTitle_question">;
  readonly " $fragmentType": "EditQuestionCard_formQuestion";
};
export type EditQuestionCard_formQuestion$key = {
  readonly " $data"?: EditQuestionCard_formQuestion$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditQuestionCard_formQuestion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditQuestionCard_formQuestion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuestionTitle_question"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuestionInputs_question"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuestionControls_question"
    }
  ],
  "type": "FormQuestion",
  "abstractKey": null
};

(node as any).hash = "ff1f69732db78779b87f86be35d88638";

export default node;
